import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import List from 'pages/offical/faq/components/list/main';
import React, { FC } from 'react';
import styles from './styles.scss';



const FaqsSection: FC<{}> = (props) => {
	const { transData } = useTranslation('prices.faqs');

	return (
		<section className={styles['ac-faqs']} id='faqs'>
			<div className={styles['ac-faqs-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				<div className={styles['ac-faqs-list']}>
					<List listData={transData.list} transData={transData} isHtml />
				</div>
			</div>
		</section>
	);

}

export default FaqsSection
